import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styles from './PasswordPrompt.module.scss';

const PasswordPrompt = ({ onSubmit, onCancel }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const correctPassword = 'medicubeAdmin';
  const [userGroup, setUserGroup] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isDisabled) return;

    if (password === correctPassword) {
      onSubmit();
    } else {
      setError('Incorrect password. Try again.');
    }
  };

  const getPracticeConsentClauseData = async () => {
    try {
      const { data } = await axios.get('/user');
      const userGroup = data[1].group; 
      setUserGroup(userGroup);
      setIsAdmin(userGroup === 'admin'); 
      setIsSuperAdmin(userGroup === 'superadmin'); 

      
      const currentPath = window.location.pathname;
      if (userGroup === 'user' || (userGroup === 'admin' && currentPath === '/password_admin')) {
        setIsDisabled(true); // Disable the button
      } else {
        setIsDisabled(false); // Enable the button
      }
      console.log('User group:', userGroup, 'Current path:', currentPath);
    } catch (error) {
      console.error('Error fetching user data:', error);
    }
  };

  const handleCancel = () => {
    window.location.replace('/dashboard');
  };

  useEffect(() => {
    getPracticeConsentClauseData();
  }, []);

  return (
    <div className={styles.page}>
      <main className={styles.passwordPrompt} aria-labelledby="password-prompt-title">
        <img src="/logo.png" alt="Medicube" className={styles.logo} />
        <h1 id="password-prompt-title">Dashboard access</h1>
        <p className={styles.description}>Enter your password to continue.</p>

        <form onSubmit={handleSubmit}>
          <label htmlFor="dashboard-password" className={styles.label}>Password</label>
          <input
            id="dashboard-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
              setError('');
            }}
            placeholder="Enter password"
            className={styles.input}
            aria-invalid={Boolean(error)}
            aria-describedby={error ? 'dashboard-password-error' : undefined}
            required
          />
          {error && <p id="dashboard-password-error" className={styles.errorText} role="alert">{error}</p>}
          {isDisabled && <p className={styles.warningText} role="status">This account cannot access these reports.</p>}
          <button type="submit" className={styles.submitButton} disabled={isDisabled}>
            Continue
          </button>
        </form>

        <button type="button" onClick={handleCancel} className={styles.cancelButton}>
          Back to dashboard
        </button>
      </main>
    </div>
  );
};

export default PasswordPrompt;
